const TITLE = {
    text: 'test',
    align: 'left',
    style: {
        fontSize: '24px',
        fontFamily: 'Montserrat", sans-serif',
        fontWeight: 600,
    },
}

export default class AppexChartWrapper {
    title(args) {
        return {
            ...TITLE,
            ...args,
        }
    }
}
